import {Component, Input, OnInit} from '@angular/core';
import {BrowseComponent} from "@shared/components/browse/abstract.browse.component";
import {NzModalService} from "ng-zorro-antd";
import {CommonsService} from "@core/service/commons.service";
import {Pagination} from "@core/bean/pagination";
import {Observable} from "rxjs/index";
import {HttpParams} from "@angular/common/http";
import {BrowseConfig} from "@core/bean/browse-config";
import {PriceParityService} from "../../../../routes/jy-srm/inquiry-parity/priceParity/priceParity.service";
import {Sort} from "@core/bean/sort";
import {Direction} from "@core/bean/direction";

@Component({
  selector: 'app-price-repository-browse',
  templateUrl: './Price-comparison-browse.html',
  styles: []
})
export class PriceComparisonBrowse implements BrowseComponent, OnInit {

  static componentName = 'PriceComparisonBrowse';

  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  createdBy:any;
  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private service:PriceParityService
  ) {
    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return service.getByFinished(params);
    }
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    // 浏览框架添加排序规则
    this.pagination.addSort(new Sort('priceList.orderNo',Direction.DESC));
    this.pagination.toFirstPage();
  }

  reset(){
    this.searchData = this.config.searchData;
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }


  // selectBasePlant(result) {
  //   this.pagination.searchData['plants.plantCode'] = result.plantCode;
  //   this.pagination.searchData['plants.plantName'] = result.plantName;
  // }
  // clearBasePlant() {
  //   this.pagination.searchData['plants.plantCode'] = null;
  //   this.pagination.searchData['plants.plantName'] = null;
  // }

}
